module.exports = __webpack_public_path__ + "static/media/Mt_Mitchell_State_Park_Museum_diorama_progress_in_the_studio_2_2016.a8072715.webp";